/* eslint-disable jira/filename-case */
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

let ssrFailedMarker = false;
let failedMarkers = new Set<string>();

autoBeforeEachTest(() => {
	ssrFailedMarker = false;
	failedMarkers = new Set();
});

/**
 * @internal only for local usage by rendering guard
 */
export const markSSRFailure = (fallbackId: string | undefined): void => {
	ssrFailedMarker = true;
	if (fallbackId != null) {
		failedMarkers.add(fallbackId);
	}
};

/**
 * reports if SSR failure was reported via ReportSSRFailOnUse
 */
export const hasFailedSSR = (): boolean => ssrFailedMarker;
export const getFailedMarkers = (): Set<string> => failedMarkers;
